import React from 'react'
import { MarketProvider } from './src/components/MarketContext'
import Layout from './src/components/Layout'

let scrollObserver

function initScrollAnimations() {
  scrollObserver?.disconnect()
  if (!window.IntersectionObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  scrollObserver = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return
      target.animate?.([
        { transform: 'translateY(16px)' },
        { transform: 'translateY(0)' },
      ], { duration: 350, easing: 'ease-out' })
      scrollObserver.unobserve(target)
    })
  }, { threshold: 0.1 })

  document.querySelectorAll('.content-block, .visual-block').forEach(element => {
    if (element.getBoundingClientRect().top >= window.innerHeight) scrollObserver.observe(element)
  })
}

export const onInitialClientRender = () => {
  document.documentElement.classList.replace('no-js', 'js')
  initScrollAnimations()
}

export const onRouteUpdate = () => {
  if (typeof window === 'undefined') return
  window.requestAnimationFrame(initScrollAnimations)
}

export const wrapRootElement = ({ element }) => (
  <MarketProvider>{element}</MarketProvider>
)

export const wrapPageElement = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
)
